module.exports = __webpack_public_path__ + "static/media/colors-average.455894dc.svg";